import Sidebar from "./Sidebar";
import logo from "../assets/images/logo.svg";
import { Link } from "react-router-dom";
export default function Layout({ children }) {
  return (
    <>
      <nav className="max-w-[90rem] mx-auto py-4 fixed top-0 w-full left-1/2 -translate-x-1/2 px-4 md:px-0">
      <Link to={"/"} > <img alt="LWS Logo" src={logo} /> </Link>
      </nav>
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
        <Sidebar />
        <div className="lg:pl-[14rem]  mt-[5.8125rem]">{children}</div>
      </div>
    </>
  );
}
